// import React from "react";
// import { Label, Input, FormFeedback } from "reactstrap";

// const CustomAmountInput = ({
//   label,
//   name,
//   type = "text",
//   className = "",
//   id,
//   onChange,
//   onBlur,
//   value,
//   invalid,
//   field,
//   mandatory,
//   disable,
// }) => {
//   return (
//     <div className="d-flex flex-column border-1 border-black justify-content-center ">
//      {} <Label htmlFor={id}>{field}  {mandatory && <span style={{color: 'red'}}>*</span>}</Label> 
     

//       <div
//         className="d-flex flex-row justify-content-start align-items-center"
//         style={{
//           gap: "4px",
//          // border: invalid ? "1px solid red" : "",
//          // borderColor: invalid ? " #5b626b" : "",
//          border : invalid ?  "1px solid red" : "1px solid #e9ecef",
         
//         //  borderColor: invalid ? "red" : "black",
//           borderRadius: invalid ? "5px" : "5px",
//         }}
//       >
//         { label && <div style={{ padding: "8px" }}>{label}</div>}
       
//         <Input
//           style={{ width: "100%" , paddingLeft:"-5px"}}
//           name={name}
//           type={type}
//           className={`form-control border-0 ${className}`}
//           id={id}
//           onChange={onChange}
//           onBlur={onBlur}
//           value={value || ""}
//           invalid={invalid}
//           placeholder="0.00"
//           disabled={disable}

//         />
//       </div>
//       {invalid && (
//         <FormFeedback style={{ display: "block" }} type="invalid">
//           This field is required
//         </FormFeedback>
//       )}
//     </div>
//   );
// };

// export default CustomAmountInput;


// import React, { useState } from "react";
// import { Label, Input, FormFeedback } from "reactstrap";


// const CustomAmountInput = ({
//   label,
//   name,
//   type = "text",
//   className = "",
//   id,
//   onChange,
//   onBlur,
//   value,
//   invalid,
//   field,
//   mandatory,
//   disable,
// }) => {
//   // Local state to handle input value
//   const [inputValue, setInputValue] = useState(value || "");
//   const [flag ,setFlag] = useState(true);


//   // Function to format the input value to two decimal places
//   const formatToTwoDecimalPlaces = (val) => {
//     const numValue = parseFloat(val);
//     if (!isNaN(numValue)) {
//       return numValue.toFixed(2);
//     }
//     return ""; // Default to "0.00" if the input is invalid or empty
//   };

//   // Handle input change
//   const handleChange = (e) => {
//     setInputValue(e.target.value);
//     if (onChange) {
//       onChange(e); // Pass the raw input value for onChange
//     }
//   };

//   // Handle input blur and apply formatting
//   const handleBlur = (e) => {
//     const formattedValue = formatToTwoDecimalPlaces(e.target.value);
//     setInputValue(formattedValue); // Update local state with formatted value

//     if (onBlur) {
//       // Pass the formatted value to onBlur
//       if(e.target.value === "" && e.target.value === 0) {
//         setFlag(false);
//       } 
//       onBlur({ ...e, target: { ...e.target, value: formattedValue } });
//     }
//   };

//   return (
//     <div className="d-flex flex-column border-1 border-black justify-content-center ">
//       <Label htmlFor={id}>
//         {field} {mandatory && <span style={{ color: "red" }}>*</span>}
//       </Label>

//       <div
//         className="d-flex flex-row justify-content-start align-items-center"
//         style={{
//           gap: "4px",
//           border: invalid ? "1px solid red" : "1px solid #e9ecef",
//           borderRadius: "5px",
//         }}
//       >
//         {label && <div style={{ padding: "8px" }}>{label}</div>}

//         <Input
//           style={{ width: "100%", paddingLeft: "-5px" }}
//           name={name}
//           type={type}
//           className={`form-control border-0 ${className}`}
//           id={id}
//           onChange={handleChange} // Handle raw value change
//           onBlur={handleBlur} // Apply formatting on blur
//           value={inputValue} // Local state to control input value
//           invalid={invalid}
//           placeholder="0.00"
//           disabled={disable}
//         />
//       </div>
//       {invalid && (
//         <FormFeedback style={{ display: "block" }} type="invalid">
//           This field is required
//         </FormFeedback>
//       )}
//     </div>
//   );
// };

// export default CustomAmountInput;



import React, { useState, useEffect } from "react";
import { Label, Input, FormFeedback } from "reactstrap";

const CustomAmountInput = ({
  label,
  name,
  type = "text",
  className = "",
  id,
  onChange,
  onBlur,
  value,
  invalid,
  field,
  mandatory,
  disable,
}) => {
  // Local state to handle input value
  const [inputValue, setInputValue] = useState(value || "");
  const [flag, setFlag] = useState(true);

  // Sync local state with the value prop when it changes
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  // Function to format the input value to two decimal places
  const formatToTwoDecimalPlaces = (val) => {
    const numValue = parseFloat(val);
    if (!isNaN(numValue)) {
      return numValue.toFixed(2);
    }
    return ""; // Default to "" if the input is invalid or empty
  };

  // Handle input change
  const handleChange = (e) => {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e); // Pass the raw input value for onChange
    }
  };

  // Handle input blur and apply formatting
  const handleBlur = (e) => {
    const formattedValue = formatToTwoDecimalPlaces(e.target.value);
    setInputValue(formattedValue); // Update local state with formatted value

    if (onBlur) {
      // Pass the formatted value to onBlur
      if (e.target.value === "" && e.target.value === 0) {
        setFlag(false);
      }
      onBlur({ ...e, target: { ...e.target, value: formattedValue } });
    }
  };

  return (
    <div className="d-flex flex-column border-1 border-black justify-content-center ">
      <Label htmlFor={id}>
        {field} {mandatory && <span style={{ color: "red" }}>*</span>}
      </Label>

      <div
        className="d-flex flex-row justify-content-start align-items-center"
        style={{
          gap: "4px",
          border: invalid ? "1px solid red" : "1px solid #e9ecef",
          borderRadius: "5px",
        }}
      >
        {label && <div style={{ padding: "8px" }}>{label}</div>}

        <Input
          style={{ width: "100%", paddingLeft: "-5px" }}
          name={name}
          type={type}
          className={`form-control border-0 ${className}`}
          id={id}
          onChange={handleChange} // Handle raw value change
          onBlur={handleBlur} // Apply formatting on blur
          value={inputValue} // Local state to control input value
          invalid={invalid}
          placeholder="0.00"
          disabled={disable}
        />
      </div>
      {invalid && (
        <FormFeedback style={{ display: "block" }} type="invalid">
          This field is required
        </FormFeedback>
      )}
    </div>
  );
};

export default CustomAmountInput;
